import { registerComponent } from '@gig/magic-common';
import KeycloakInfoComponent from './keycloak-info.vue.js';

var KeycloakInfo = registerComponent(KeycloakInfoComponent);

export { KeycloakInfo };
